/**
 * File: userProfile.js
 * Project: educore
 * Created Date: 2019-03-18
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class UserProfileController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, authService, MEDICALCONSTANT) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        let academicYear = localStorageService.get('academic_year')
        $scope.isShowFilter = false
        $scope.isSelected = false
        let patientId
        $scope.selectedUsers = localStorageService.get('selectedUsers')
        if ($scope.selectedUsers && $scope.selectedUsers.length === 1) {
            patientId = $scope.selectedUsers[0].patient_id
            $scope.role = $scope.selectedUsers[0].role
        }

        $scope.allUserDetails = []
        if ($scope.selectedUsers && $scope.selectedUsers.length > 1) {
            $scope.selectedPersonDetails = []
            _.each($scope.selectedUsers, function(eachUser) {
                /* Meteor.call('getPersonDetails', schoolId, eachUser.user_id, (error, result) => {
                     if (error) {} else {
                         if (result.image) {
                             if (result.image.original) {
                                 result.image.original = FILE_PREVIEW_URL + result.image.original
                             }
                         }
                         $scope.selectedPersonDetails.push(result)
                     }
                     $scope.$apply()

                 })*/

            })

        } else {
            getMedicalProfile()
        }

        function getMedicalProfile() {
            let reqObj = {
                patient_id: patientId,
                role: $scope.role
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_MEDICAL_PROFILE, "POST", reqObj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    if (response.result.data.data.length > 0) {
                        $scope.userDetails = response.result.data.data[0]
                        let curriculumName = ($scope.userDetails.curriculum && $scope.userDetails.curriculum.name) ? $scope.userDetails.curriculum.name : ""
                        let className = ($scope.userDetails.class && $scope.userDetails.class.name) ? $scope.userDetails.class.name : ""
                        let batchName = ($scope.userDetails.batch && $scope.userDetails.batch.name) ? $scope.userDetails.batch.name : ""
                        let sessionName = ($scope.userDetails.session && $scope.userDetails.session.name) ? $scope.userDetails.session.name : ""
                        if (curriculumName && sessionName && sessionName && batchName)
                            $scope.userDetails['academicDet'] = curriculumName + '/' + sessionName + '/' + className + batchName
                        if ($scope.userDetails.incidents && $scope.userDetails.incidents.length > 0)
                            $scope.incidentList = $scope.userDetails.incidents
                        getImmuzationForm()

                    }
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        function getImmuzationForm() {
            let reqObj = {
                patient_id: patientId,
                academic_year: academicYear,
                school_id: schoolId
            }
            $scope.immunizationReply = []
            $scope.medicalQuestions = []
            authService.callAPI(MEDICALCONSTANT.API_GET_IMMUNIZATION_FORM, "POST", reqObj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    if (response.result.data.data) {
                        let resultData = response.result.data.data
                        if (resultData.questions && resultData.questions.questions)
                            $scope.medicalQuestions = resultData.questions.questions
                        if (resultData.reply && resultData.reply.questions_answers)
                            $scope.immunizationReply = resultData.reply.questions_answers
                        if (resultData.reply && resultData.reply.status === "sent") {
                            $scope.viewAnswers = false
                            $scope.sent_date = resultData.reply.sent_date
                        } else if (resultData.reply && resultData.reply.status === "replied") {
                            $scope.viewAnswers = true
                            $scope.sent_date = resultData.reply.sent_date
                            $scope.reply_date = resultData.reply.reply_date
                        }
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }

                }
            })
        }
        let ansQues = []
        $scope.medicalhistory = [{
            title: "VIEW ALL HISTORY"
        }]
        if ($scope.medicalhistory) {
            if ($scope.medicalhistory.length > 0) {
                $scope.medicalhistory[0].expanded = true;
            }

        }
        $scope.collapseMedicalHistory = function(expa) {
            for (var i in $scope.medicalhistory) {
                if ($scope.medicalhistory[i] != expa) {
                    $scope.medicalhistory[i].expanded = false;
                    if ($scope.showImmunization) {
                        $scope.showImmunizationCreateButton = false
                    }

                }
            }
            expa.expanded = !expa.expanded;
        };
        $scope.collapseHistory = function(expa) {
            for (var i in self.incidentList) {
                if (self.incidentList[i] != expa) {
                    self.incidentList[i].expanded = false;
                }
            }
            expa.expanded = !expa.expanded;
        };
        $scope.selectAll = (isSelected) => {
            _.each($scope.medicalQuestions, function(obj) {
                obj.selected = isSelected ? true : false
            })
        }
        $scope.selectQuestion = () => {
            let selectedCount = 0
            _.each($scope.medicalQuestions, function(obj) {
                if (obj.selected === true)
                    selectedCount++
            })
            if ($scope.medicalQuestions.length === selectedCount)
                $scope.isSelected = true
            else
                $scope.isSelected = false

        }

        $scope.immunizationDivShow = () => {
            let userDetails = Person.findOne({
                user_id: userId,
                "status": "active"
            })
            let selectedRole = userDetails.role_ids
            if (selectedRole.indexOf("student") !== -1) {
                if (!userDetails.parent_id) {
                    toastr.error('Parents are not mapped')
                } else {
                    $scope.showImmunization = true
                    $scope.showImmunizationCreateButton = false
                }
            } else {
                $scope.showImmunization = true
                $scope.showImmunizationCreateButton = false
            }
        }

        $scope.exportFilter = () => {
            $scope.isShowFilter = true
            $scope.isShowexportButton = false
            $scope.t_type = {}
            $scope.selectDate = null
            $scope.t_type.weekly = false
            $scope.t_type.monthly = false
            $scope.t_type.dailyOrNot = false
            $scope.incident_type = {}
            $scope.faDisable = false
            $scope.vaDisable = false
            $scope.riDisable = false
            $scope.submit = () => {}
            $scope.week = false
            $scope.month = false
            $scope.daily = false
            $scope.weeklyOnChange = () => {
                if ($scope.t_type.weekly == true) { //on change for weekly
                    $scope.month = true
                    $scope.daily = true
                } else {
                    $scope.month = false
                    $scope.daily = false
                }
            }
            $scope.monthlyOnChange = () => { //on change for monthly
                if ($scope.t_type.monthly) {
                    $scope.week = true
                    $scope.daily = true
                } else {
                    $scope.week = false
                    $scope.daily = false
                }
            }
            $scope.dailyOnChange = () => {
                if ($scope.t_type.dailyOrNot == true) { //on change for daily
                    $scope.week = true
                    $scope.month = true
                } else {
                    $scope.week = false
                    $scope.month = false
                }
            }

            $scope.iFaChange = () => {
                // $scope.faDisable = false

                if ($scope.incident_type.FA_I === true) {
                    $scope.vaDisable = true
                    $scope.riDisable = true
                } else {
                    $scope.vaDisable = false
                    $scope.riDisable = false
                }
            }
            $scope.iVaChange = () => {

                if ($scope.incident_type.V_I === true) {
                    $scope.faDisable = true
                    $scope.riDisable = true
                } else {
                    $scope.faDisable = false
                    $scope.riDisable = false
                }
            }
            $scope.iRiChange = () => {

                if ($scope.incident_type.R_I === true) {
                    $scope.faDisable = true
                    $scope.vaDisable = true
                } else {
                    $scope.faDisable = false
                    $scope.vaDisable = false
                }
            }
        }

        $scope.cancel = function() {
            $mdDialog.hide();
        };
        $scope.redirectToCreate = () => {
            if (patientId) {
                $state.go("incidents", {
                    patientId: patientId
                })
            } else {
                $state.go("incidents", {
                    patientId: ""
                })
            }
        }
        $scope.sendDiagnosticQuestions = () => {
            if (!$scope.medicalQuestions) {
                $scope.medicalQuestions = []
            }
            let questionSetCount = $scope.medicalQuestions.length
            let selectedQuestions = _.where($scope.medicalQuestions, {
                    selected: true
                }) 
            if (selectedQuestions.length === 0) {
                toastr.error("Please select atleast one question")
            } else {
                let reqObj = {
                    question_set: selectedQuestions,
                    school_id: schoolId,
                    selected_users: $scope.selectedUsers,
                    user_id: userId,
                    academic_year: academicYear
                }
                authService.callAPI(MEDICALCONSTANT.API_SEND_IMMUNIZATION_FORM, "POST", reqObj, (response) => {
                    if (response.result && response.result.data && response.result.data.data) {
                        toastr.success("Immunization form sent Successfully")
                        getImmuzationForm()
                        _.defer(function() {
                            $scope.$apply();
                        });

                    }
                })
            }
        }
    }
}

export default UserProfileController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/userProfile.js